import bus, { eventNames } from '@/lib/eventBus'

type SnackbarType = 'success' | 'error' | 'warning' | 'info'
// Rendered by BaseSnackbar.vue after the main text — `link` may be an absolute
// external URL (opened in a new tab) or an internal app route.
type SnackbarTexts = Array<{ text: string; link?: string }>

export const showSnackbarMessage = (
  type: SnackbarType,
  text: string,
  texts?: SnackbarTexts
): void => {
  bus.$emit(eventNames.SHOW_SNACKBAR, {
    color: type,
    text: text,
    texts,
  })
}
